import { render, staticRenderFns } from "./API.vue?vue&type=template&id=58028996&"
import script from "./API.vue?vue&type=script&lang=ts&"
export * from "./API.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports